import React from "react";
import { format12Hour, isClosed } from "../../utils/TimeFormat";
import { Dealer, DealerDetails } from "../../models";
import classNames from "classnames";

interface Props {
  dealerDetails: DealerDetails;
  collapsible: boolean;
}

interface State {
  isExpanded: boolean;
}

class OpeningHours extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  handleChange() {
    if (this.props.collapsible) {
      this.setState({
        isExpanded: !this.state.isExpanded,
      });
    }
  }

  render() {
    const {
      monFriOpen,
      monFriClose,
      satOpen,
      satClose,
      sunOpen,
      sunClose,
      satExtraInfo,
      additionalOpeningInfo,
      sunExtraInfo,
    } = this.props.dealerDetails;
    const { isExpanded } = this.state;

    let hours;

    const d = new Date();
    const today = d.getDay();

    const hoursClass = classNames({
      "dealer-hours": true,
      "is-collapsible": this.props.collapsible,
      "is-expanded": this.props.collapsible && this.state.isExpanded,
    });

    const todayClass = classNames({
      "dealer-hours-expanded": true,
      "is-weekday":
        today === 5 || today === 4 || today === 3 || today === 2 || today === 1,
      "is-sat": today === 6,
      "is-sun": today === 0,
    });

    if (
      today === 5 ||
      today === 4 ||
      today === 3 ||
      today === 2 ||
      today === 1
    ) {
      if (!isClosed(monFriOpen)) {
        hours = `Open today ${format12Hour(monFriOpen)} - ${format12Hour(
          monFriClose
        )}`;
      } else {
        hours = `Closed today`;
      }
    } else if (today === 6) {
      if (!isClosed(satOpen)) {
        hours = `Open today ${format12Hour(satOpen)} - ${format12Hour(
          satClose
        )}`;
      } else {
        hours = `Closed today`;
      }
    } else if (today === 0) {
      if (!isClosed(sunOpen)) {
        hours = `Open today ${format12Hour(sunOpen)} - ${format12Hour(
          sunClose
        )}`;
      } else {
        hours = `Closed today`;
      }
    }

    if (monFriOpen === null || satOpen === null || sunOpen === null) {
      hours = "";
    }

    return !!monFriOpen && hours !== "" ? (
      <div className={hoursClass} onClick={() => this.handleChange()}>
        <p>{`${hours}`}</p>
        {isExpanded && (
          <p className={todayClass}>
            <span className="weekday">
              {isClosed(monFriOpen)
                ? `Mon-Fri: Closed`
                : `Mon-Fri: ${format12Hour(monFriOpen)}-${format12Hour(
                    monFriClose
                  )}`}
            </span>
            {additionalOpeningInfo && (
              <span>
                <br />
                <span className="weekday">{additionalOpeningInfo}</span>
              </span>
            )}
            <br />
            <span className="sat">
              {isClosed(satOpen)
                ? `Sat: Closed`
                : `Sat: ${format12Hour(satOpen)} - ${format12Hour(satClose)}`}
            </span>
            {satExtraInfo && isClosed(satOpen) && (
              <span>
                <br />
                <span className="sat">{satExtraInfo}</span>
              </span>
            )}
            <br />
            <span className="sun">
              {isClosed(sunOpen)
                ? `Sun: Closed`
                : `Sun: ${format12Hour(sunOpen)} - ${format12Hour(sunClose)}`}
            </span>
            {sunExtraInfo && isClosed(sunOpen) && (
              <span>
                <br />
                <span className="sun">{sunExtraInfo}</span>
              </span>
            )}
          </p>
        )}
      </div>
    ) : (
      <span />
    );
  }
}

export default OpeningHours;
